/// <reference path="../../lib/app.d.ts" />

import {Translator} from "../utils/translator";
export class TipAfterShowPanel
{
	private perfID: string;
	private options = [200, 300, 400, 500, 750];
	private selected : number;
	private onClose: Function;
	private screenName: string;

	constructor(
		private $root : JQuery,
		private translator : Translator,
		onPicked : (roomID : string, amount : number, message : string, onResult : (res : boolean, reason : string) => void) => void
	)
	{
		let $picker = this.$root.find(".sxcc-tas-picker").empty();
		for (let i = 0; i < this.options.length; i++)
		{
			let $item = $("<div class='sxcc-tas-item' />")
				.data("id", i)
				.append(
					$("<div class='sxcc-tas-item-inner' />").append(
						$("<div class='amount' />").text(this.options[i]),
						$("<div class='currency' />").text(this.translator.t("__currency"))
					)
				);

			$picker.append($item);
		}

		$picker.on("click", ".sxcc-tas-item", (e) => {
			let item = parseInt($(e.currentTarget).data("id"));
			this.select(item);
			this.$root.find("textarea").focus()
		});

		this.$root.find("form").submit((e) => {
			e.preventDefault();
			onPicked(
				this.perfID,
				this.options[this.selected],
				this.$root.find("textarea").val(),
				(success : boolean, reason : string) => {
					this.showResult(success, reason);
				}
			);
		});

		this.$root.find(".sxcc-tas-close").click((e) => {
			this.hide();
		});
	}

	show(mode : string, perfID : string, screenName : string, profilePic : string, onClose : Function = null)
	{
		this.$root.addClass("sxc-visible");

		this.$root.find(".sxcc-tip-after-show").addClass("sxc-visible");
		this.$root.find(".sxcc-tip-after-show-result").removeClass("sxc-visible");

		this.$root.removeClass("mode-normal mode-ban");
		this.$root.addClass("mode-" + mode);

		this.$root.find(".mode-normal")[mode === "ban" ? "removeClass" : "addClass"]("sxc-visible");
		this.$root.find(".mode-ban")[mode !== "ban" ? "removeClass" : "addClass"]("sxc-visible");

		if (mode === "ban")
		{
			let mottos = this.$root.find(".sxcc-tas-motto .mode-ban");
			let rnd = Math.floor(Math.random() * mottos.length);
			mottos.removeClass("sxc-visible");
			mottos.eq(rnd).addClass("sxc-visible");
		}

		this.$root.find(".sxcc-tas-screenname .value").text(screenName);
		this.$root.find(".sxcc-tas-pic img").attr("src", profilePic);
		this.$root.find("textarea").val("").focus();

		this.perfID = perfID;
		this.screenName = screenName;
		this.onClose = onClose;
		this.select(2);
	}

	hide()
	{
		if (this.onClose) {this.onClose()}
		this.onClose = null;

		this.$root.removeClass("sxc-visible");
	}

	select(id : number)
	{
		this.selected = id;
		this.$root.find(".sxcc-tas-item").removeClass("sxc-selected");
		this.$root.find(".sxcc-tas-item").eq(id).addClass("sxc-selected");
	}

	isVisible()
	{
		return this.$root.hasClass("sxc-visible");
	}

	private showResult(success: boolean, reason : string = null)
	{
		this.$root.find(".sxcc-tip-after-show").removeClass("sxc-visible");
		this.$root.find(".sxcc-tip-after-show-result").addClass("sxc-visible");

		this.$root.find(".sxcc-tas-result-message").text(
			success
				? this.translator.t("tip_after_chat_success").replace("{{name}}", this.screenName)
				: this.translator.t("tip_after_chat_fail_" + reason)
		);

		setTimeout(() => {
			this.hide();
		}, 5000);
	}
}
